import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createItemFailed,
  createItemRequested,
  createItemSucceeded,
  deleteItemFailed,
  deleteItemRequested,
  deleteItemSucceeded,
  updateItemFailed,
  updateItemRequested,
  updateItemSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createItemRequest(data) {
  yield put(createItemRequested(data));

  try {
    const { item } = yield call(request, api.createItem, data);

    const action = createItemSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createItemFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateItemRequest(id, data) {
  yield put(updateItemRequested(id, data));

  try {
    const { item } = yield call(request, api.updateItem, id, data);

    const action = updateItemSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateItemFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteItemRequest(id) {
  yield put(deleteItemRequested(id));

  try {
    const { item } = yield call(request, api.deleteItem, id);

    const action = deleteItemSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteItemFailed(id, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
